import { useState, useRef, useEffect } from 'react';

export function useDeckState() {
  const [openDeckId, setOpenDeckId] = useState(null);
  const [hoveredDeck, setHoveredDeck] = useState(null);
  const [fannedDeckMobile, setFannedDeckMobile] = useState(null);
  const [returnToDeckId, setReturnToDeckId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const isClosingRef = useRef(false);
  const isOpeningRef = useRef(false);
  const isMobile = useRef(false);

  // Detect if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileUA = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      const isTouchOnly = 'ontouchstart' in window && navigator.maxTouchPoints > 0 && window.innerWidth < 1024;
      isMobile.current = isMobileUA || isTouchOnly;
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Auto-close fanned deck on scroll
  useEffect(() => {
    if (fannedDeckMobile === null) return;

    const handleScroll = () => {
      if (fannedDeckMobile !== null) {
        setFannedDeckMobile(null);
        setHoveredDeck(null);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [fannedDeckMobile]);

  // Close fanned deck when clicking outside
  useEffect(() => {
    if (fannedDeckMobile === null) return;

    const handleClickOutside = (e) => {
      // Check if click is outside the fanned deck area
      const deckElement = document.querySelector(`[data-deck-id="${fannedDeckMobile}"]`);
      if (deckElement && !deckElement.contains(e.target)) {
        setFannedDeckMobile(null);
        setHoveredDeck(null);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => document.removeEventListener('click', handleClickOutside, true);
  }, [fannedDeckMobile]);

  const handleDeckClick = (deckId, e) => {
    e?.stopPropagation();
    
    if (isMobile.current) {
      if (fannedDeckMobile === deckId) {
        if (!openDeckId && !isClosingRef.current && !isOpeningRef.current) {
          isOpeningRef.current = true;
          setOpenDeckId(deckId);
          setFannedDeckMobile(null);
          setHoveredDeck(null);
          setTimeout(() => isOpeningRef.current = false, 500);
        }
      } else {
        setFannedDeckMobile(deckId);
        setHoveredDeck(deckId);
      }
    } else {
      if (!openDeckId && !isClosingRef.current && !isOpeningRef.current) {
        isOpeningRef.current = true;
        setOpenDeckId(deckId);
        setHoveredDeck(null);
        setTimeout(() => isOpeningRef.current = false, 500);
      }
    }
  };

  const closeDeck = () => {
    setOpenDeckId(null);
  };

  const handleProductClick = (deckId, product) => {
    setReturnToDeckId(deckId);
    setOpenDeckId(null);
    setSelectedProduct(product);
  };

  const closeProductModal = () => {
    if (returnToDeckId) {
      setOpenDeckId(returnToDeckId);
      setReturnToDeckId(null);
    }
    setSelectedProduct(null);
  };

  const closeFannedDeck = () => {
    if (fannedDeckMobile !== null) {
      setFannedDeckMobile(null);
      setHoveredDeck(null);
    }
  };

  return {
    openDeckId,
    setOpenDeckId,
    hoveredDeck,
    setHoveredDeck,
    fannedDeckMobile,
    setFannedDeckMobile,
    selectedProduct,
    setSelectedProduct,
    returnToDeckId,
    setReturnToDeckId,
    isMobile,
    isClosingRef,
    isOpeningRef,
    handleDeckClick,
    closeDeck,
    handleProductClick,
    closeProductModal,
    closeFannedDeck
  };
}
